import React from 'react'
import Link from 'next/link'

interface PrimaryButtonProps {
  children: React.ReactNode
  onClick?: () => void
  href?: string
  className?: string
  type?: 'button' | 'submit' | 'reset'
  fullWidth?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'px-4 py-2.5 text-sm',
  md: 'px-5 py-3 text-[15px]',
  lg: 'px-6 py-3.5 text-[15px]'
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  onClick,
  href,
  className = '',
  type = 'button',
  fullWidth = false,
  size = 'md'
}) => {
  const baseClasses = 'primary-button inline-flex items-center justify-center rounded-xl border border-accent/20 bg-accent font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#4f72f4] hover:shadow-[0_14px_28px_rgba(91,127,255,0.18)]'
  const sizeClass = sizeClasses[size]
  const widthClass = fullWidth ? 'w-full' : ''
  const combinedClasses = `${baseClasses} ${sizeClass} ${widthClass} ${className}`.trim()
  const isInternalHref =
    !!href && (href.startsWith('/') || href.startsWith('#'))

  if (href) {
    if (!isInternalHref) {
      return (
        <a
          href={href}
          className={combinedClasses}
        >
          {children}
        </a>
      )
    }

    return (
      <Link
        href={href}
        className={combinedClasses}
      >
        {children}
      </Link>
    )
  }

  return (
    <button
      type={type}
      onClick={onClick}
      className={combinedClasses}
    >
      {children}
    </button>
  )
}

export default PrimaryButton
